import Routers from './layout/Routers';
import { UserProvider } from './util/Context';
import { CartProvider } from './util/CartContext';
import './App.css';

function App() {
  return (
    <div className="">
      <UserProvider>
        <CartProvider>
          <Routers />
        </CartProvider>
      </UserProvider>
    </div>
  );
}

export default App;
